import { useContext, useMemo } from 'react';
import { useMutation, useQueryClient } from 'react-query';
import deleteGreetsAction from '~/actions/greets/deleteGreetsAction';
import deleteGreetAction from '~/actions/greets/deleteGreetAction';
import { confirmAsync } from '~/App/Components/Modals/Confirm';
import { Greet } from '~/types/models';
import pluralize from 'pluralize';
import TodoListContext from '~/App/Modules/TodoList/Context';
import { useHistory } from 'react-router';

export function useDeleteGreets(greets: Greet[]) {
  const queryClient = useQueryClient();
  const { bulkSelect } = useContext(TodoListContext);
  const history = useHistory();

  const greetIds = useMemo(() => {
    return greets.map((greet) => greet.id);
  }, [greets]);

  const { mutateAsync: deleteGreet } = useMutation(
    (greetId: string) => deleteGreetAction(greetId),
    {
      onSuccess: () => queryClient.invalidateQueries('todos'),
    }
  );

  const { mutateAsync: deleteGreets } = useMutation(
    (greetIds: string[]) => deleteGreetsAction(greetIds),
    {
      onSuccess: () => queryClient.invalidateQueries('todos'),
    }
  );

  async function handleDeleteClick() {
    if (
      await confirmAsync(
        `Are you sure you want to dismiss ${
          greets.length > 1
            ? pluralize('task', greets.length, true)
            : 'this task'
        }?`
      )
    ) {
      if (greetIds.length > 1) {
        await deleteGreets(greetIds);
      } else {
        await deleteGreet(greetIds[0]);
      }

      if (bulkSelect.data.any) {
        bulkSelect.uncheckAll();
      }

      history.replace('/home/greet/redirect');
    }
  }

  return {
    handleDeleteClick,
  };
}
